import Slide from "@material-ui/core/Slide"
import PropTypes from "prop-types"
import { useQuery } from "react-query"
import { listTags } from "~/actions/courses"
import CourseLessonContentContainer from "~/components/Common/CourseLessonContentContainer"
import PathCourses from "~/components/Paths/PathCourses"
import PathDetails from "~/components/Paths/PathDetails"
import Page from "~/pages/Page"
import Router from "~/router"

import Box from "../../../../../../components/Common/Box"
import useStyles from "./styles"

function TransitionDown(props) {
  return <Slide {...props} direction="up" />
}

const Content = ({ routes = [], ...rest }) => {
  const classes = useStyles()
  const { data: tags } = useQuery("tags", () => listTags())

  return (
    <Page>
      <Box className={classes.container}>
        <CourseLessonContentContainer
          leftComponent={<PathDetails tags={tags} />}
          rightComponent={<PathCourses />}
        />
        <Router routes={routes} {...rest} />
      </Box>
    </Page>
  )
}

Content.propTypes = {
  routes: PropTypes.array,
}

export default Content
